// import PerfectScrollbar from 'perfect-scrollbar';
import { formatGameTime } from '../../game/helpers/formatters';

const ID_ATTRIBUTE_NAME = 'data-user-id';

export default class Leaderboard {
    wrapperEl;
    listEl;
    scrollbar;

    constructor(wrapper) {
        this.wrapperEl = wrapper;
        this.listEl = this.wrapperEl.querySelector('.js-leaderboard-list');

        // this.initScrollbar();
    }

    // initScrollbar() {
    //     this.scrollbar = new PerfectScrollbar(this.wrapperEl, {
    //         suppressScrollX: true
    //     });
    // }

    fillWithData(data) {
        let resultHtml = '';

        data = data.filter((item) => !!item?.id);

        data.forEach((item, index) => {
            const itemHtml = this.createItemHtml(item, index + 1);

            resultHtml = `${resultHtml}${itemHtml}`;
        });

        this.listEl.innerHTML = resultHtml;
    }

    // eslint-disable-next-line class-methods-use-this
    createItemHtml(item, place) {
        return `
            <li class="leaderboard__item" ${ID_ATTRIBUTE_NAME}="${item.user_id}" data-session-id="${item.id}">
                <div class="leaderboard__item-place">${place}</div>
                <div class="leaderboard__item-info">
                    <div class="leaderboard__item-time">${formatGameTime(item.score)}</div>
                    <div class="leaderboard__item-user">${item.name}</div>
                </div>
            </li>
        `;
    }

    showResultById(id) {
        const element = this.listEl.querySelector(`[${ID_ATTRIBUTE_NAME}='${id}']`);

        if (!element) return;

        const scrollAnchorElement = element.previousElementSibling?.previousElementSibling;

        element.classList.add('active');

        const elementToScrollTo = scrollAnchorElement || element;

        elementToScrollTo.scrollIntoView();
    }
}
